import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=609d518e&scoped=true"
import script from "./VersionUpdate.vue?vue&type=script&lang=js"
export * from "./VersionUpdate.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=609d518e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d518e",
  null
  
)

export default component.exports